import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Buyer-facing e-way tracking lives in the main app; we route sellers to the same screen
 * so they can monitor status alongside the buyer (CM production flow).
 */
export default function SellerCmProductionEwayTrackingPage() {
  const { rfqId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const id = rfqId ? Number(rfqId) : null;
    navigate(id ? `/eway-bill-tracking?cmRfqId=${encodeURIComponent(String(id))}` : "/eway-bill-tracking", {
      replace: true,
      state: { cmRfqId: id },
    });
  }, [rfqId, navigate]);

  return (
    <div className="container py-5">
      <p className="text-muted mb-0">Opening e-way tracking…</p>
    </div>
  );
}
